module.exports = __webpack_public_path__ + "img/02.b353ea71.png";